import { TARGETING_ATTRIBUTE, TARGETING_OPERATOR } from '../constants'
import { createLocalId } from './ids'

export const createEmptyTargetingRow = (overrides = {}) => ({
  id: createLocalId('target'),
  attribute: TARGETING_ATTRIBUTE.age,
  operator: TARGETING_OPERATOR.equals,
  value: '',
  ageBasis: '',
  lockedByAnchor: false,
  ...overrides,
})
